module.exports = __webpack_public_path__ + "static/img/icon-01.f91a33a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-01.png
// module id = u73/
// module chunks = 1